"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var platform_browser_1 = require("@angular/platform-browser");
var menu_directive_1 = require("./menu.directive");
var NguiMenuModule = (function () {
    function NguiMenuModule() {
    }
    return NguiMenuModule;
}());
NguiMenuModule = __decorate([
    core_1.NgModule({
        imports: [platform_browser_1.BrowserModule, forms_1.FormsModule],
        declarations: [menu_directive_1.NguiMenuDirective],
        exports: [menu_directive_1.NguiMenuDirective]
    }),
    __metadata("design:paramtypes", [])
], NguiMenuModule);
exports.NguiMenuModule = NguiMenuModule;
//# sourceMappingURL=menu.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngui/menu/dist/menu.module.js
// module id = 548
// module chunks = 4